/*
export function someGetter (state) {
}
*/

export function creationLoading(state) {
  return state.newCollection.loading;
}
